export default "__VITE_ASSET__CAS_YB54__"